import { apiUrl } from '@monorepo/shared/apiClient/httpClient';
import { fileTypeFromMime } from '@monorepo/shared/utils/documentFileType';
import { format } from 'date-fns';
import { DocumentFileResponse } from 'mapistry-shared';
import React from 'react';
import { TableColumn } from '../Table/types';
import { DocumentFileNameCell } from './DocumentFileNameCell';

interface GetDocumentFileColumnsParams {
  actions?: (document: DocumentFileResponse) => React.ReactElement | string;
}

export function getDocumentFileColumns({
  actions,
}: GetDocumentFileColumnsParams = {}): TableColumn<DocumentFileResponse>[] {
  const columns: TableColumn<DocumentFileResponse>[] = [
    {
      id: 'name',
      header: 'Name',
      contents: (doc) => (
        <DocumentFileNameCell
          name={doc.name}
          downloadUrl={`${apiUrl}${doc.downloadUrl}`}
        />
      ),
    },
    {
      id: 'createdAt',
      header: 'Date Added',
      contents: (doc) => format(new Date(doc.createdAt), 'P'),
      align: 'center',
      width: '20%',
    },
    {
      id: 'fileType',
      header: 'File Type',
      contents: (doc) => fileTypeFromMime(doc.mimeType, doc.name),
      align: 'center',
      width: '15%',
    },
    {
      id: 'createdBy',
      header: 'Created By',
      contents: (doc) => doc.createdBy?.name ?? '',
      align: 'center',
      width: '15%',
    },
  ];

  if (actions) {
    columns.push({
      id: 'actions',
      header: 'Actions',
      contents: actions,
      align: 'center',
      width: '10%',
    });
  }

  return columns;
}
